import { api, apiUrl } from "../../../shared/services/service";
import {
  SisterSearcherPerformanceResponse,
  SisterSearcherSearchRequest,
  SisterSearcherSearchResponse,
  SisterSearcherVesselsResponse,
} from "../models/sister-searcher.models";

export const getSisterSearcherVessels = async (
  query: string,
  limit: number,
  signal: AbortSignal,
): Promise<SisterSearcherVesselsResponse> => {
  const response = await api.get<SisterSearcherVesselsResponse>(`${apiUrl}/pbi/sister-searcher/vessels`, {
    params: { ...(query ? { q: query } : {}), limit },
    signal,
  });

  return response.data;
};

export const searchSisterSearcherVessels = async (
  request: SisterSearcherSearchRequest,
  signal: AbortSignal,
): Promise<SisterSearcherSearchResponse> => {
  const response = await api.get<SisterSearcherSearchResponse>(`${apiUrl}/pbi/sister-searcher/search`, {
    params: request,
    signal,
  });

  return response.data;
};

export const getSisterSearcherPerformance = async (
  imos: string[],
  signal: AbortSignal,
): Promise<SisterSearcherPerformanceResponse> => {
  const response = await api.get<SisterSearcherPerformanceResponse>(`${apiUrl}/pbi/sister-searcher/performance`, {
    params: { imos: imos.join(",") },
    signal,
  });

  return response.data;
};
